import React from 'react';
import { BonusGem, CostRow } from '../CardSection/Card';
import './ReserveModal.css';

export default function ReserveModal({ reserveInfo, bankGold, tokenTotal, onConfirm, onCancel, busy }) {
  const card = reserveInfo?.card;
  const tier = reserveInfo?.tier;
  const willGetGold = bankGold > 0;
  const willExceed = willGetGold && tokenTotal >= 10;

  const colorCls = card ? card.color.toLowerCase() : '';

  return (
    <div className="modal-overlay">
      <div className="reserve-modal">
        <h3>预定卡牌</h3>

        {/* Card preview */}
        {card ? (
          <div className="reserve-modal__card-preview">
            <div className={`reserve-modal__card ${colorCls}`}>
              <div className={`reserve-modal__card-art ${colorCls}`}>
                <span className="sparkle" /><span className="sparkle" /><span className="sparkle" />
              </div>
              <div className="reserve-modal__card-info">
                <div className="reserve-modal__card-header">
                  <span className="reserve-modal__card-pts">{card.points || 0}</span>
                  <BonusGem color={card.color} size={22} />
                </div>
                <CostRow cost={card.cost} className="reserve-modal__card-cost" />
              </div>
            </div>
          </div>
        ) : (
          <div className="reserve-modal__blind">
            <div className={`reserve-modal__blind-deck level${tier}`}>
              <span>Lv.{tier}</span>
              <span className="reserve-modal__blind-label">盲抽</span>
            </div>
          </div>
        )}

        {/* Gold info */}
        <div className="reserve-modal__info">
          {willGetGold ? (
            <p className="reserve-modal__gold-msg">
              <span className="gem-pip gold" style={{ width: 22, height: 22, fontSize: 11 }}>G</span>
              {' '}将获得 1 个金币
              {willExceed && <span className="reserve-modal__warn">（需归还1个宝石）</span>}
            </p>
          ) : (
            <p className="reserve-modal__no-gold">银行无金币，不会获得金币</p>
          )}
          <p className="reserve-modal__token-count">当前持有宝石：{tokenTotal}/10</p>
        </div>

        <div className="reserve-modal__actions">
          <button className="btn-primary" onClick={onConfirm} disabled={busy}>
            确认预定
          </button>
          <button className="btn-secondary" onClick={onCancel} disabled={busy}>
            取消
          </button>
        </div>
      </div>
    </div>
  );
}
